<template>
    <div class="kt-container  kt-container--fluid  kt-grid__item kt-grid__item--fluid">
        <div class="kt-portlet kt-portlet--mobile">
            <div class="kt-portlet__head kt-portlet__head--lg no-border-radius">
                <div class="kt-portlet__head-label">
                    <div class="row center">
                        <Dropdown v-model="selectedOrg" :options="organizations" optionLabel="display_name"
                            :placeholder="$t('AppMachineReportCOA.Organização')" class="auto-center" :dataKey="'id'"
                            :filter="true" @input="saveChosenOptionsToLocalStorage" style="width: 250px">
                            <template #option="slotProps" style="width: 500px">
                                <div v-if="loadingOrgs">{{ $t('AppMachineReportCOA.Carregando, aguarde') }}</div>
                                <div style="padding-right: 20px" v-else-if="slotProps.option.name === 'ND'">
                                    -
                                </div>
                                <div style="padding-right: 20px" v-else>
                                    {{ slotProps.option.display_name }}
                                </div>
                            </template>
                        </Dropdown>
                    </div>
                </div>
            </div>
            <div class="kt-portlet__body no-padding">
                <div class="card data-table-width">
                    <DataTable :value="gridData" :paginator="true" :rows="50" :rowHover="true" :loading="loading"
                        filterDisplay="row" :filters.sync="filters" :sortOrder="-1" stripedRows
                        paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                        :rowsPerPageOptions="[10, 25, 50]" responsiveLayout="scroll"
                        :currentPageReportTemplate="$t('AppMachineReportCOA.currentPageReportTemplate')"
                        class="p-datatable-striped">
                        <template #header>
                            <div style="display: flex; justify-content: space-between;">
                                <div>
                                    <h4>{{ $t('AppMachineReportCOA.Relatório de Máquinas - COA') }}</h4>
                                </div>
                                <div>
                                    <Button icon="pi pi-refresh" :label="$t('AppMachineReportCOA.Atualizar Lista')" class="p-button-rounded p-button-info" @click="getMachineReportByOrg()"
                                            style="background-color: #2196F3; border-color: #2196F3;"/>
                                    <Button icon="pi pi-plus" :label="$t('AppMachineReportCOA.Novo Relatório')" class="p-button-rounded p-button-success" @click="openDialog"
                                            style="background-color: #3CBEB4; border-color: #3CBEB4; margin-left: 10px;"/>
                                </div>
                            </div>
                        </template>
                        <template #empty>
                            {{ $t('AppMachineReportCOA.Sem dados para exibir') }}
                        </template>
                        <template #loading>
                            {{ $t('AppMachineReportCOA.Carregando veículos, por favor aguarde') }}
                        </template>
                        <Column field="identification" :header="$t('AppMachineReportCOA.Identificação')" :styles="{ 'min-width': '11rem' }"
                            headerClass="headerClass" :showFilterMenu="false" :showClearButton="false"
                            bodyClass="bodyClass" :sortable="true">
                            <template #body="slotProps">
                                <span>{{ slotProps.data.identification }}</span>
                            </template>
                            <template #filter="{ filterModel, filterCallback }">
                                <InputText type="text" v-model="filterModel.value" @input="filterCallback()"
                                    class="p-column-filter" />
                            </template>
                        </Column>
                        <Column field="vin" :header="$t('AppMachineReportCOA.Chassi')" :styles="{ 'min-width': '11rem' }"
                            headerClass="headerClass" :showFilterMenu="false" :showClearButton="false"
                            bodyClass="bodyClass" :sortable="true">
                            <template #body="slotProps">
                                <span>{{ slotProps.data.vin }}</span>
                            </template>
                            <template #filter="{ filterModel, filterCallback }">
                                <InputText type="text" v-model="filterModel.value" @input="filterCallback()"
                                    class="p-column-filter" />
                            </template>
                        </Column>
                        <Column field="start_date" :header="$t('AppMachineReportCOA.Início')" :styles="{ 'min-width': '11rem' }"
                            headerClass="headerClass" :showFilterMenu="false" :showClearButton="false"
                            bodyClass="bodyClass" :sortable="true">
                            <template #body="slotProps">
                                <span>{{ dateHourFormat(slotProps.data.start_date) }}</span>
                            </template>
                            <template #filter="{ filterModel, filterCallback }">
                                <InputText type="text" v-model="filterModel.value" @input="filterCallback()"
                                    class="p-column-filter" />
                            </template>
                        </Column>
                        <Column field="end_date" :header="$t('AppMachineReportCOA.Fim')" :styles="{ 'min-width': '11rem' }"
                            headerClass="headerClass" :showFilterMenu="false" :showClearButton="false"
                            bodyClass="bodyClass" :sortable="true">
                            <template #body="slotProps">
                                <span>{{ dateHourFormat(slotProps.data.end_date) }}</span>
                            </template>
                            <template #filter="{ filterModel, filterCallback }">
                                <InputText type="text" v-model="filterModel.value" @input="filterCallback()"
                                    class="p-column-filter" />
                            </template>
                        </Column>
                        <Column field="progress" :header="$t('AppMachineReportCOA.Progresso')" :styles="{ 'min-width': '11rem' }"
                            headerClass="headerClass" :showFilterMenu="false" :showClearButton="false"
                            bodyClass="bodyClass" :sortable="true">
                            <template #body="slotProps">
                                <span>{{ slotProps.data.progress }}</span>
                            </template>
                            <template #filter="{ filterModel, filterCallback }">
                                <InputText type="text" v-model="filterModel.value" @input="filterCallback()"
                                    class="p-column-filter" />
                            </template>
                        </Column>
                        <Column field="status" :header="$t('AppMachineReportCOA.Status')" :styles="{ 'min-width': '11rem' }"
                            headerClass="headerClass" :showFilterMenu="false" :showClearButton="false"
                            bodyClass="bodyClass" :sortable="true">
                            <template #body="slotProps">
                                <span :class="'badge machine-report-status-' + slotProps.data.status" style="font-weight: bold">
                                    {{ getStatus(slotProps.data.status) }}
                                </span>
                            </template>
                            <template #filter="{ filterModel, filterCallback }">
                                <InputText type="text" v-model="filterModel.value" @input="filterCallback()"
                                    class="p-column-filter" />
                            </template>
                        </Column>
                        <Column :styles="{'max-width':'3rem'}" headerClass="headerClass" bodyClass="bodyClass">
                            <template #body="slotProps">
                                <div>
                                    <Button v-if="slotProps.data.status === 'SUCCESS'" :icon="slotProps.data.isDownloading ? 'pi pi-spin pi-spinner' : 'pi pi-download'" 
                                        class="p-button-rounded m-1" @click="downloadCsv(slotProps.data)" />
                                </div>
                            </template>
                        </Column>
                        <Column :styles="{'max-width':'3rem'}" headerClass="headerClass" bodyClass="bodyClass">
                            <template #body="slotProps">
                                <div>
                                    <Button icon="pi pi-trash" class="p-button-rounded p-button-danger m-1" @click="deleteCSV(slotProps.data)" />
                                </div>
                            </template>
                        </Column>
                    </DataTable>
                </div>
            </div>
            <Dialog :header="$t('AppMachineReportCOA.Novo relatório')" :visible.sync="reportDialog" :modal="true">
                <div style="width: 600px;">
                    <div style="font-size: 15px; margin-bottom: 5px;">{{ $t('AppMachineReportCOA.Selecione o veículo') }}</div>

                    <Dropdown v-model="selectedVehicles" :options="vehicles" optionLabel="identification"
                        :placeholder="$t('AppMachineReportCOA.Veículo')" class="auto-center" :dataKey="'id'" 
                        style="width: 250px" :filter="true">
                        <template #option="slotProps" style="width: 500px">
                            <div v-if="loadingVehicles">{{ $t('AppMachineReportCOA.Carregando, aguarde') }}</div>
                            <div style="padding-right: 20px" v-else>
                                {{ slotProps.option.identification }}
                            </div>
                        </template>
                    </Dropdown>

                    <div style="font-size: 15px; margin-bottom: 5px;margin-top: 15px">{{ $t('AppMachineReportCOA.Selecione o período') }}</div>

                    <div style="display: flex; border-top: 1px solid #dddddd; border-bottom: 1px solid #dddddd;">
                        <div style="border-right: 1px solid #dddddd; width: 60%; padding-top: 3px;">
                            <Calendar v-model="newReportDate" selectionMode="range" :inline="true" style="width: calc(100% - 3px);" class="time-calendar">
                                <template #footer>
                                    <div style="display: flex;text-align: center; margin-top: 20px">
                                        <div style="flex: 0 0 50%">
                                            <div>{{ $t('AppMachineReportCOA.Hora Inicial') }}</div>
                                            <Calendar class="time-calendar" :inline="true" :showWeek="true" :timeOnly="true" v-model="start_time"/>
                                        </div>
                                        <div style="flex: 1">
                                            <div>{{ $t('AppMachineReportCOA.Hora Final') }}</div>
                                            <Calendar class="time-calendar" :inline="true" :showWeek="true" :timeOnly="true" v-model="end_time"/>
                                        </div>
                                    </div>
                                </template>
                            </Calendar>
                        </div>

                        <div style="width: 40%; text-align: center; align-items: center; justify-content: center; display: flex; flex-direction: column;">
                            <div style="height: 50%; width: 100%; align-items: center; justify-content: center; display: flex; flex-direction: column;
                                    border-bottom: 1px solid #dddddd;">
                                <div style="font-size: 16px; font-weight: bold;">{{ $t('AppMachineReportCOA.Inicio') }}</div>
                                <div style="font-size: 16px;">{{ newReportDate && newReportDate[0] ? dateHourFormat(Date.parse(newReportDate[0]) / 1000) : '-' }}</div>
                            </div>
                            <div style="height: 50%; width: 100%; align-items: center; justify-content: center; display: flex; flex-direction: column;">
                                <div style="font-size: 16px; font-weight: bold;">{{ $t('AppMachineReportCOA.Fim') }}</div>
                                <div style="font-size: 16px;">{{ newReportDate && newReportDate[1] ? dateHourFormat(Date.parse(newReportDate[1]) / 1000) : '-' }}</div>
                            </div>
                        </div>
                    </div>
                </div>
                <template #footer>
                    <div style="position: relative; bottom: 4px;">
                        <Button :label="$t('AppMachineReportCOA.Cancelar')" icon="pi pi-times" @click="reportDialog = false" class="p-button-danger"/>
                        <Button :label="$t('AppMachineReportCOA.Confirmar')" icon="pi pi-check" @click="sendNewReport" />
                    </div>
                </template>
            </Dialog>
            <Dialog :visible.sync="deleteReport" :header="$t('AppMachineReportCOA.Deletar')" :modal="true">
                <div class="confirmation-content">
                    <i class="pi pi-exclamation-triangle p-mr-3" style="font-size: 15px; margin-right: 10px"/>
                    <span>{{ $t('AppMachineReportCOA.Tem certeza que deseja deletar o relatório') }}</span>
                </div>
                <template #footer>
                    <Button :label="$t('AppMachineReportCOA.Não')" icon="pi pi-times" class="p-button-text" @click="deleteReport = false"/>
                    <Button :label="$t('AppMachineReportCOA.Sim')" icon="pi pi-check" class="p-button-text" @click="confirmDelete"/>
                </template>
            </Dialog>
        </div>
    </div>
</template>

<script>
import OrganizationsService from "@/services/OrganizationsService";
import VehiclesService from "@/services/VehiclesService";
import MachineReportCOAService from "@/services/MachineReportCOAService";

import DataTable from 'primevue/datatable';
import Column from 'primevue/column';
import InputText from 'primevue/inputtext';
import Calendar from 'primevue/calendar';
import Dropdown from 'primevue/dropdown';
import Button from 'primevue/button'
import Dialog from 'primevue/dialog';
import orderCustomFieldByNaturalOrder from "@/mixins/ArrayMixin";
import dateHourFormat from "@/mixins/DateMixin";
import {FilterMatchMode} from 'primevue/api';
import {FilterService} from 'primevue/api';
import displayToast from '@/mixins/ToastMixin';
const DATE_FILTER = 'DATE FILTER';
const STATUS_FILTER = 'STATUS FILTER';

export default {
    mixins: [orderCustomFieldByNaturalOrder, displayToast, dateHourFormat],
    created() {
        this.organizationsService = new OrganizationsService();
        this.vehiclesService = new VehiclesService();
        this.machineReportCOAService = new MachineReportCOAService();
    },
    mounted: function () {
        this.getOrganizations();
        FilterService.register(DATE_FILTER, (value, filter) => {
            if (filter === undefined || filter === null || filter.trim() === '') {
                return true;
            }
            if (value === undefined || value === null) {
                return false;
            }
            return this.dateHourFormat(value).includes(filter);
        });
        FilterService.register(STATUS_FILTER, (value, filter) => {
            if (filter === undefined || filter === null || filter.trim() === '') {
                return true;
            }
            if (value === undefined || value === null) {
                return false;
            }
            return this.getStatus(value).toLowerCase().includes(filter);
        });
    },
    data() {
        return {
            vehiclesService: null,
            machineReportCOAService: null,
            filters: {
                'vin': { value: null, matchMode: FilterMatchMode.CONTAINS },
                'identification': { value: null, matchMode: FilterMatchMode.CONTAINS },
                'start_date': { value: null, matchMode: DATE_FILTER },
                'end_date': { value: null, matchMode: DATE_FILTER },
                'progress': { value: null, matchMode: FilterMatchMode.CONTAINS },
                'status': { value: null, matchMode: STATUS_FILTER }
            },
            loading: false,
            loadingVehicles: false,
            gridData: [],
            organizationsService: null,
            loadingOrgs: false,
            selectedOrg: null,
            selectedVehicles: null,
            organizations: [],
            storedChosenOptions: {},
            vehicles: [],
            reportDialog: false,
            start_time: new Date(1970, 0, 0, 0, 0, 0, 0),
            end_time: new Date(1970, 0, 0, 23, 59, 59, 0),
            newReportDate: null,
            deleteReport: false,
            itemSelectedToDelete: null
        }
    },
    methods: {
        getOrganizations() {
            let vm = this;
            this.loadingOrgs = true;
            this.organizationsService.getAllV3('VEHICLES').then((results) => {
                this.populateOrgsList(results);
                this.loadFilteredOptions();
            }).catch((error) => {
                vm.$toast.add({
                    severity: 'error',
                    summary: this.$t('AppMachineReportCOA.Operação falhou'),
                    detail: this.$t('AppMachineReportCOA.Não foi possível buscar organizações'),
                    life: 5000
                });
                console.log(error)
            }).finally(() => {
                this.loadingOrgs = false;
            })
        },
        populateOrgsList(orgs) {
            this.organizations = this.orderCustomFieldByNaturalOrder(orgs, "name");
        },
        loadFilteredOptions() {
            this.storedChosenOptions = JSON.parse(localStorage.getItem(process.env.VUE_APP_LOCAL_STORAGE_FILTER_BAR_OPTIONS));

            if (!this.storedChosenOptions || !this.storedChosenOptions.clients || this.storedChosenOptions.clients.length === 0) {
                this.storedChosenOptions = {};
                return;
            }

            this.selectedOrg = this.storedChosenOptions['clients'].filter(a => this.organizations.some(b => a.id === b.id))[0];
        },
        saveChosenOptionsToLocalStorage() {
            this.storedChosenOptions['clients'] = [this.selectedOrg];
            this.storedChosenOptions['vehicles'] = [];
            localStorage.setItem(process.env.VUE_APP_LOCAL_STORAGE_FILTER_BAR_OPTIONS, JSON.stringify(this.storedChosenOptions));
        },
        getVehiclesByOrg() {
            this.loadingVehicles = true
            this.vehiclesService.getVehiclesByOrgV3(this.selectedOrg.id).then(data => {
                    data.forEach(element => {
                        element.identification = element.identification ? element.identification : element.identification_number
                    });
                    this.vehicles = data;
                    this.getMachineReportByOrg()
                }).catch(error => {
                    this.gridData = []
                    this.reportDialog = false
                    this.displayToast(this.$t('AppMachineReportCOA.Não foi possivel completar a operação, tente novamente'), 'e', error)
                }).finally(() => {
                    this.loadingVehicles = false;
                });
        },
        getMachineReportByOrg() {
            if(this.gridData.some(item => item.isDownloading)){
                this.displayToast(this.$t('AppMachineReportCOA.Aguarde o download do arquivo'), 'e')
                return
            }

            this.loading = true
            this.machineReportCOAService.getMachineReport(this.selectedOrg.id).then(data => {
                    data.forEach(element => {
                        element.progress = element.steps === 0 || element.total_steps === 0 ? '0%' : Math.trunc((element.steps / element.total_steps) * 100) + '%';
                        element.isDownloading = false;
                        let vehicle = this.vehicles.find(v => v.identification_number === element.vin)
                        element.identification = vehicle ? vehicle.identification : ''
                    });
                    this.gridData = data;
                }).catch(error => {
                    this.displayToast(this.$t('AppMachineReportCOA.Não foi possivel completar a operação, tente novamente'), 'e', error)
                }).finally(() => {
                    this.loading = false;
                });
        },
        getStatus(code) {
            switch (code) {
                case 'PENDING':
                    return this.$t('AppMachineReportCOA.Pendente');
                case 'SUCCESS':
                    return this.$t('AppMachineReportCOA.Processado');
                case 'ERROR':
                    return this.$t('AppMachineReportCOA.Erro');
            }
        },
        openDialog() {
            if(this.gridData.some(item => item.isDownloading)){
                this.displayToast(this.$t('AppMachineReportCOA.Aguarde o download do arquivo'), 'e')
                return
            }

            this.selectedVehicles = null
            this.newReportDate = null
            this.start_time = new Date(1970, 0, 0, 0, 0, 0, 0)
            this.end_time = new Date(1970, 0, 0, 23, 59, 59, 0)
            this.reportDialog = true
        },
        downloadCsv(val){
            if(this.gridData.some(item => item.isDownloading)){
                this.displayToast(this.$t('AppMachineReportCOA.Aguarde o download do arquivo'), 'e')
                return
            }
            
            val.isDownloading = true
            this.machineReportCOAService.downloadCsv(val.id, this.selectedOrg.id)
                .then(response => {
                    this.loadCSV(response, val)
                    val.isDownloading = false
                }).catch((error) => {
                    val.isDownloading = false
                    this.displayToast(this.$t('AppMachineReportCOA.Não foi possível fazer o download, tente novamente mais tarde'), 'e', error)
            });
        },
        loadCSV(csvData, val) {
            let fileName = `${val.vin}.csv`;
            let blob = new Blob([csvData], {type: 'text/csv'});
            let url = window.URL.createObjectURL(blob);
            let link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', fileName);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        },
        deleteCSV(val){
            if(this.gridData.some(item => item.isDownloading)){
                this.displayToast(this.$t('AppMachineReportCOA.Aguarde o download do arquivo'), 'e')
                return
            }

            this.itemSelectedToDelete = val
            this.deleteReport = true
        },
        confirmDelete(){
            this.deleteReport = false
            this.machineReportCOAService.deleteMachineReport(this.itemSelectedToDelete.id)
                .then(response => {
                    this.displayToast(this.$t('AppMachineReportCOA.Relatório deletado com sucesso'), 's')
                    this.getMachineReportByOrg()
                }).catch((error) => {
                    this.displayToast(this.$t('AppMachineReportCOA.Não foi possível deletar o relatório'), 'e', error)
                });
        },
        sendNewReport(){
            if(this.selectedVehicles === null) {
                this.displayToast(this.$t('AppMachineReportCOA.Selecione ao menos um veículo'), 'e')
                return
            }

            if(!this.newReportDate || !this.newReportDate[0] || !this.newReportDate[1]){
                this.displayToast(this.$t('AppMachineReportCOA.Selecione o período!'), 'e')
                return
            }

            if(this.newReportDate[0] > this.newReportDate[1]){
                this.displayToast(this.$t('AppMachineReportCOA.Data final deve ser maior que a inicial!'), 'e')
                return
            }

            let start_date = Date.parse(this.newReportDate[0]) / 1000;
            let end_date = Date.parse(this.newReportDate[1]) / 1000;

            let diffInSeconds = end_date - start_date;
            let dayInSeconds = 24 * 60 * 60;
            let maxDiff = 10 * dayInSeconds;

            if (diffInSeconds > maxDiff) {
                this.displayToast(this.$t('AppMachineReportCOA.O período máximo permitido é de 10 dias'), 'e')
                return
            }

            let params = {
                vid: this.selectedVehicles.id,
                vin: this.selectedVehicles.identification_number,
                start_date,
                end_date,
                total_steps: Math.ceil(diffInSeconds / dayInSeconds)
            }
            this.machineReportCOAService.createMachineReport(this.selectedOrg.id, params).then(data => {
                    this.getMachineReportByOrg()
                    this.reportDialog = false
                    this.displayToast(this.$t('AppMachineReportCOA.Relatório solicitado com sucesso'), 's')
                }).catch(error => {
                    this.displayToast(this.$t('AppMachineReportCOA.Não foi possivel completar a operação, tente novamente'), 'e', error)
                })
        },
        updateReportDate(val) {
            if (!val) {
                return
            }

            if (val[0]) {
                val[0].setHours(this.start_time.getHours());
                val[0].setMinutes(this.start_time.getMinutes());
            }

            if (val[1]) {
                val[1].setHours(this.end_time.getHours());
                val[1].setMinutes(this.end_time.getMinutes());
                val[1].setSeconds(59);
            }
        },
    },
    watch: {
        selectedOrg: function () {
            this.getVehiclesByOrg()
        },
        start_time(val) {
            if (this.newReportDate && this.newReportDate[0]) {
                this.newReportDate[0].setHours(val.getHours());
                this.newReportDate[0].setMinutes(val.getMinutes());
                this.newReportDate = [...this.newReportDate]
            }
        },
        end_time(val) {
            if (this.newReportDate && this.newReportDate[1]) {
                this.newReportDate[1].setHours(val.getHours());
                this.newReportDate[1].setMinutes(val.getMinutes());
                this.newReportDate[1].setSeconds(59);
                this.newReportDate = [...this.newReportDate]
            }
        },
        newReportDate(val) {
            this.updateReportDate(val);
        }
    },
    components: {
        DataTable, Column, InputText, Calendar, Dropdown, Button, Dialog
    }
}
</script>

<style scoped lang="scss">
@import "../style";

.time-calendar {
    margin-bottom: 5px;
    outline: 5px solid white;
    outline-offset: -2px;
}

</style>